/** Document title from index.html loaded on first read */
export const appTitle = document.title;
